module.exports = __webpack_public_path__ + "static/media/image20.82a201af.JPG";